import { Logger } from 'next-axiom';

type HumorLevel = 1 | 2 | 3 | 4 | 5;

interface HumorSettings {
    level: HumorLevel;
    description: string;
}

const humorMap: Record<HumorLevel, HumorSettings> = {
    1: {
        level: 1,
        description: 'No humor. Answers are strictly factual and serious.'
    },
    2: {
        level: 2,
        description:
            'Slight humor. Answers may contain light, unobtrusive humor.'
    },
    3: {
        level: 3,
        description:
            'Moderate humor. Answers are friendly and can contain jokes or puns.'
    },
    4: {
        level: 4,
        description: 'High humor. Answers often contain humor, jokes, or puns.'
    },
    5: {
        level: 5,
        description:
            'Very high humor. Almost all responses contain some form of humor.'
    }
};

export function getHumorSettings(level: HumorLevel): HumorSettings {
    const log = new Logger();
    log.debug('using humor ', { humor: humorMap[level] });
    return humorMap[level];
}

export function numberToHumorLevel(num: number): HumorLevel {
    if (num < 1 || num > 5) {
        throw new Error('Invalid humor level. It should be between 1 and 5.');
    }
    return num as HumorLevel;
}

export type { HumorLevel, HumorSettings };
